<template>
    <div class="content">
        <div class="lds-dual-ring"></div>
        <div class="activation-status">{{status}}</div>
    </div>
</template>

<script>
export default {
    name: "Loading",
    props: {
        status: String
    }
};
</script>

<style scoped>
.content {
    text-align: center;
    margin: auto;
    width: 300px;
}

.activation-status {
    color: #fff;
    font-size: 18px;
    font-weight: 300;
    margin: auto;
    padding: 70px 40px 40px 40px;
    display: block;
}

.lds-dual-ring {
    position: relative;
    top: 40px;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 40px;
    height: 40px;
}
.lds-dual-ring:after {
    content: " ";
    display: block;
    width: 40px;
    height: 40px;
    margin: 1px;
    border-radius: 50%;
    border: 4px solid #adccc6;
    border-top-color: #a2f434;
    animation: lds-dual-ring 0.75s linear infinite;
}
@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>

